import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Roles } from "../../components/routing/utils";

import Cameras from "./page.highorder";

const ProtectedCameras = () => (
  <AuthorizedRoute
    requiredRoles={[Roles.ADMIN, Roles.NURSEADMIN]}
    component={Cameras}
  />
);

const camerasRoute= (
  <Route path="/manage-cameras" element={<ProtectedCameras />} />
);

export default camerasRoute;
